import { apiRoutes } from 'routes';
import FetchHelpers from 'utils/FetchHelpers';

export default {
  create(params) {
    const path = apiRoutes.sessionPath();
    return FetchHelpers.post(path, params);
  },
};
